import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import Api from "services/api"


export const initialState = {
  admin: [],
  error: null,
  loader: false,
  featured: {},
  total: 0,
  is_more: false,
  last_page: 1
}

export const adminSlice = createSlice({
  name: 'admin',
  initialState: initialState,
  reducers: {
    setAdmin: (state, { payload }) => {
      state.admin = payload?.data ?? payload;
      state.total = payload?.total;
      state.is_more = payload?.is_more;
      state.last_page = payload?.last_page;
    },
    setAdmins: (state, { payload }) => {
      state.admin = payload?.data;
      state.total = payload?.total;
      state.is_more = payload?.is_more;
      state.last_page = payload?.last_page;
    },
    setMoreAdmins: (state, { payload }) => {
      state.data = state.data.concat(payload.data);
      state.total = payload.total;
      state.is_more = payload.is_more;
      state.last_page = payload?.last_page;
    },
    removeAdmin: (state, { payload }) => {
      state.error = payload
    },
    clearAllAdmin: (state, { payload }) => {
      state.loader = payload
    },
    setError: (state, { payload }) => {
      state.error = payload
    },
    setLoader: (state, { payload }) => {
      state.loader = payload
    },
  }
})

// const reducer = (state = initialState, action) => {
//   switch (action.type) {
//     case types.INIT_APP:
//     case types.GO_TO_DETAILS:
//       return { ...state, ...action.payload }
//     default:
//       return state
//   }
// }

export const addAdmin = (data, callback) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {

    const json = await Api.addAdmin(data)
    if (json.status >= 200 && json.status < 300) {
      console.log(json)
      // dispatch(setAdmin(json.data))
      callback(true, json.data.message)
    } else if (json.status == 422) {
      dispatch(setError(json.data))
      callback(false, json.data.message)
    }
  } catch (error) {
    console.log(error)
    // callback(false)

  }
  dispatch(setLoader(false))
}

export const updateAdmin = (data, itemId, callback) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {

    const json = await Api.updateAdmin(data, itemId)
    if (json.status >= 200 && json.status < 300) {
      console.log(json)
      // dispatch(setAdmin(json.data))
      callback(true, json.data.message)
    } else if (json.status == 422) {
      dispatch(setError(json.data))
      callback(false, json.data.message)
    }
  } catch (error) {
    console.log(error)
    // callback(false)

  }
  dispatch(setLoader(false))
}

export const removeAdmin = (itemId, callback) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {

    const json = await Api.removeAdmin(itemId)
    if (json.status >= 200 && json.status < 300) {
      console.log(json)
      // dispatch(setAdmin(json.data))
      callback(true, json.data.message)
    } else if (json.status == 422) {
      dispatch(setError(json.data))
      callback(false, json.data.message)
    }
  } catch (error) {
    console.log(error)
    // callback(false)

  }
  dispatch(setLoader(false))
}

export const fetchAdmins = (page, params, disableLoader) => async (dispatch) => {
  !disableLoader && dispatch(setLoader(true))
  try {

    const result = await Api.fetchAdmins(page, params)
    if (result.status >= 200 && result.status < 300) {
      if (page > 1) {
        dispatch(setAdmins(result.data.data));
      } else {
        dispatch(setAdmins(result.data.data));
      }
    }
    else if (result?.status == 422) {
      dispatch(setError(result.data))
    }
  } catch (error) {
    console.log("error", error)

  }
  !disableLoader &&  dispatch(setLoader(false))
}


export const changeStatus = (id, data) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {

    const json = await Api.statusChange(id, data, "admin")
    if (json.status >= 200 && json.status < 300) {
      // console.log(json)
      // dispatch(setHospital(json.data))
      // callback(true, json.data.message)
    } else if (json.status == 422) {
      dispatch(setError(json.data))
      // callback(false, json.data.message)
    }
  } catch (error) {
    console.log(error)
    // callback(false)

  }
  dispatch(setLoader(false))
}

export const removeMultipleAdmins = (ids, callback) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {

    const json = await Api.removeMultipleAdmins(ids)
    if (json.status >= 200 && json.status < 300) {
      console.log(json)
      // dispatch(setHospital(json.data))
      callback(true, json.data.message)
    } else if (json.status == 422) {
      dispatch(setError(json.data))
      callback(false, json.data.message)
    }
  } catch (error) {
    console.log(error)
    // callback(false)

  }
  dispatch(setLoader(false))
}

export const { setAdmin, setAdmins, clearAllAdmin, setLoader, setError, setMoreAdmins } = adminSlice.actions


export default adminSlice.reducer
export const adminSelector = state => state.admin


